// From VITE_DEMO_BANNER_URL at build time: where the demo banner's button
// leads (to buy the product). Empty or absent: no banner, as in a real app.
export const DEMO_BANNER_URL: string | undefined = import.meta.env
  .VITE_DEMO_BANNER_URL;
